import { useState, useMemo } from "react";
import { toast } from "sonner";
import { loadOrders } from "../../data/adminData";
import { PageTitle, Table, Btn, dt } from "./ui";

const CARRIER = { kurjers: "DPD kurjers", pakomats: "Omniva pakomāts", veikals: "Saņemšana veikalā" };

export default function Shipments() {
  const base = useMemo(() => loadOrders().filter((o) => o.status !== "Atcelts").map((o, i) => ({
    id: `SHP-${3001 + i}`, order: o.nr, customer: o.customer || "—", carrier: CARRIER[o.delivery] || o.delivery,
    tracking: o.delivery === "veikals" ? "—" : `LV${String(84000000 + i * 977)}DEMO`,
    date: o.date, status: o.status === "Izpildīts" ? "Piegādāts" : o.status === "Nosūtīts" ? "Ceļā" : "Gatavojas",
  })), []);
  const [list, setList] = useState(base);
  const setStatus = (id, status) => setList((p) => p.map((s) => (s.id === id ? { ...s, status } : s)));
  const color = (s) => (s === "Piegādāts" ? "green" : s === "Ceļā" ? "amber" : "gray");

  return (
    <div data-testid="admin-shipments">
      <PageTitle right={<Btn onClick={() => toast.success("Manifesti nodrukāti (DEMO)", { description: "Uzlīmes un pavadzīmes visiem sūtījumiem statusā 'Gatavojas'." })} data-testid="shipments-print">Drukāt manifestus</Btn>}>
        Sūtījumi ({list.length})
      </PageTitle>
      <Table head={["Sūtījums", "Pasūtījums", "Klients", "Pārvadātājs", "Sekošanas nr.", "Datums", "Statuss"]}>
        {list.map((s) => (
          <tr key={s.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`shipment-row-${s.id}`}>
            <td className="p-3 font-bold">{s.id}</td>
            <td className="text-[#6B6B6B]">{s.order}</td>
            <td>{s.customer}</td>
            <td>{s.carrier}</td>
            <td className="font-mono text-xs">{s.tracking}</td>
            <td className="text-[#6B6B6B]">{dt(s.date)}</td>
            <td className="p-3">
              <select value={s.status} onChange={(e) => setStatus(s.id, e.target.value)} data-testid={`shipment-status-${s.id}`}
                className={`text-[11px] font-bold px-2 py-1 border-0 cursor-pointer ${s.status === "Piegādāts" ? "bg-[#1E9E45] text-white" : s.status === "Ceļā" ? "bg-[#E5A000] text-white" : "bg-[#E2E2E2]"}`}>
                {["Gatavojas", "Ceļā", "Piegādāts"].map((x) => <option key={x}>{x}</option>)}
              </select>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
